import React from 'react';
import PropTypes from 'prop-types';
import Glyph from 'components/glyph';
import RetentionInfo from './retention-info';

class PlanSelector extends React.Component {
  static propTypes = {
    plans: PropTypes.array.isRequired,
    transfer: PropTypes.string.isRequired,
    retention: PropTypes.string.isRequired,
    onLogTransferChange: PropTypes.func.isRequired,
    onLogRetentionChange: PropTypes.func.isRequired,
    disabledRetention: PropTypes.bool,
    showHelpCallout: PropTypes.bool
  }

  state = {
    isRetentionInfoVisible: false
  }

  constructor(props) {
    super(props);

    this.retentions = [
      { id: 1, text: '1 day',                  value: '1d'  },
      { id: 2, text: '3 days',                 value: '3d'  },
      { id: 3, text: '7 days',                 value: '7d'  },
      { id: 4, text: '2 weeks (most popular)', value: '14d' },
      { id: 5, text: '4 weeks',                value: '30d' }
    ];
  }

  toggleRetentionInfo = (e) => {
    if (e) e.preventDefault();
    this.setState((prevState, props) => { return { isRetentionInfoVisible: !prevState.isRetentionInfoVisible }; });
  }

  render() {
    return (
      <React.Fragment>
        <div className="plan-option mod-transfer">
          <p>
            <label>1. Choose log volume</label>
            <select onChange={this.props.onLogTransferChange} value={this.props.transfer}>
              { this.props.plans.map((plan) => <option key={plan.id} value={plan.abbreviated_transfer}>{plan.readable_transfer}/month</option>) }
            </select>
          </p>
        </div>
        <div className="plan-option">
          <p>
            <label>
              2. Choose searchable duration <a href="/account/payment" className="help-icon" onClick={this.toggleRetentionInfo}>
                <Glyph name="question-2" />
              </a>
            </label>
            <select onChange={this.props.onLogRetentionChange} value={this.props.retention} disabled={this.props.disabledRetention}>
              { this.retentions.map((r) => <option key={r.id} value={r.value}>{r.text}</option>) }
            </select>
          </p>

          { this.state.isRetentionInfoVisible && <RetentionInfo toggleRetentionInfo={this.toggleRetentionInfo} /> }
        </div>

        { this.props.showHelpCallout &&
            <p className="help-callout">
              <strong>Between plans? Not sure?</strong>
              Think of <a href="#additional-usage" rel="facebox">additional usage</a> as an infinitely flexible custom plan, or&nbsp;
              <a href="mailto:technicalsupport@solarwinds.com">get in touch</a> so we can create the ideal service.
            </p>
        }
      </React.Fragment>
    );
  }
}

export default PlanSelector;
